import React, { FC } from 'react';

import { IMerchant } from 'src/prize/types/shoppe';

import LogoComponent from '../../../../../../atoms/Logo';

import styles from './index.module.sass';

interface ILogoProps {
  merchant: IMerchant;
}

export const Logo: FC<ILogoProps> = ({ merchant }) => (
  <LogoComponent
    className={{ image: styles.logo }}
    image={merchant.logoImageUrl}
    link={merchant.domain}
    name={merchant.name}
    width={552}
  />
);
